import { createReducer, createActions } from 'reduxsauce'

// Action Types & Creators
export const { Types, Creators } = createActions({
  filterClean: [],
  filterSet: ['filters', 'deliveryDate'],
});

// Handlers
const INITIAL_STATE = {
  filters: {
    id: '',
    idEmpresa: '',
    status: '',
    naturezaPedido: '',
    ordenacao: 'sortByOrderDesc',
    fornecedor: {
      nome: '',
    },
    calendarioComercial: {
      semanaComercial: '',
    },
    cd: '',
    anoSemanaComercial: '',
    dataAgendamentoInicial: '',
    dataAgendamentoFinal: '',
    carga: ''
  },
  filterDeliveryDate: '',
};

function clean(state = INITIAL_STATE, action) {
  return { ...INITIAL_STATE }
}

function setFilter(state = INITIAL_STATE, action) {
  return { 
    ...state,
    filters: action.filters,
    filterDeliveryDate: action.deliveryDate,
  }
}

// Reducer
export default createReducer(INITIAL_STATE, {
  FILTER_CLEAN: clean,
  FILTER_SET: setFilter,
});
